import React from 'react';
import styled from '@emotion/styled';

const ScreenReaderOnly = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const VisuallyHidden = ({ children }) => (
  <ScreenReaderOnly>
    {children}
  </ScreenReaderOnly>
);

export default VisuallyHidden;
